import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import {
  Box,
  Container,
  Typography,
  Card,
} from "@material-ui/core";
import TicketStats from "../../components/ticket-stats";
import ModuleBreakdown from "../../components/module-breakdown";
import SlaCompliance from "../../components/sla-compliance";

const AnalyticsPage = ({ overview, slaData }) => (
    <>
      <Helmet>
        <title>Support Analytics | Kood Asia Management Portal</title>
      </Helmet>
      <Box sx={{ backgroundColor: "background.default", minHeight: "100%", py: 3 }}>
        <Container maxWidth={false}>
          <Card sx={{ mb: 2 }}>
            <Typography variant="h4" sx={{ padding: 2 }}>
              Support Analytics
            </Typography>
          </Card>

          {/* Overview Stats */}
          <TicketStats data={overview} />

          {/* Charts Grid */}
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", mb: 3 }}>
            <SlaCompliance data={slaData} />
            <ModuleBreakdown data={overview} />
          </Box>
        </Container>
      </Box>
    </>
);

AnalyticsPage.propTypes = {
  overview: PropTypes.object,
  slaData: PropTypes.object,
};

export default AnalyticsPage;
